
import { Component, Event, Prop, h, Host, EventEmitter } from '@stencil/core';
import { VNode } from '@genexus/designer-common';
import { renderVNodeToStencil } from '../../utils';

@Component({
    tag: 'gx-control-main-container',
    styleUrl: 'control-main-container.scss',
    shadow: false,
})
export class ControlContainer {

    @Prop() root: VNode;

    @Event() afterUpdate: EventEmitter<void>;

    componentDidLoad() {
        this.afterUpdate.emit();
    }

    componentDidUpdate() {
        this.afterUpdate.emit();
    }

    render() {
        return (
            <Host>
                {
                    renderVNodeToStencil(this.root)
                }
            </Host>
        );
    }
}

